import React from "react";
import AssistantConversation from "@/components/AssistantConversation";
import "./LiveTerminal.scss";

const LiveTerminal: React.FC = () => {
  return (
    <div className="terminal">
      <div className="terminal-bar">
        <span className="tl" /><span className="tl" /><span className="tl" />
        <span className="t-title">~/devbloom · ask-anything</span>
      </div>
      <AssistantConversation surface="inline" />
    </div>
  );
};

export default LiveTerminal;
